import { useEffect } from "react";
import { useWatch } from "react-hook-form";
import { ButtonGroup } from "../../../../../../utils/form";
import _ from "lodash";
import useFrequencyOptions from "./hooks/useFrequencyOptions";
import { equivalentFrequency } from "./frequencyOptions";

const useKeepFrequencyAvailable = (form, options, isVademecumLoaded) => {
  const selectedDays = useWatch({ control: form.control, name: "recurring.days" });
  useEffect(() => {
    const isAvailable = _.some(options, { value: selectedDays });
    if (isVademecumLoaded && selectedDays && !isAvailable)
      form.setValue("recurring.days", equivalentFrequency(selectedDays, options));
  }, [options, selectedDays, isVademecumLoaded]);
};

const RecurringFrequency = props => {
  const { options, isVademecumLoaded } = useFrequencyOptions(props.medicines);
  useKeepFrequencyAvailable(props.form, options, isVademecumLoaded);

  return (
    <ButtonGroup 
      form={props.form} 
      name="recurring.days"
      label="Se repite cada" 
      options={options} 
      valueTextGetter={(item) => item.label}
      labelStyles={{
        direction: {
          xs: "column", sm: "row"
        },
        alignItems: {
          sm: "center"
        },
        spacing: { xs: 1, sm: 2 }
      }}
    />
  );
};

export default RecurringFrequency;
